import React from 'react';
import { StackShim as Stack } from '@fluentui/react-migration-v8-v9';
import { Field, Input, FluentProvider, webLightTheme } from '@fluentui/react-components';
import { Controller, UseFormMethods } from 'react-hook-form';
import IIncorporationHierarchyInfo from '../../../../utils/types/IIncorporationHierarchyInfo';
import UtcDatePicker from '../../../common/utcDatePicker/UtcDatePicker';

interface IIncorporationHierarchyFormProps {
  form: UseFormMethods<IIncorporationHierarchyInfo>;
  data: IIncorporationHierarchyInfo;
}

const IncorporationHierarchyForm = ({
  form,
  data,
}: IIncorporationHierarchyFormProps): JSX.Element => {
  const { control, errors, setValue } = form;

  return (
    <FluentProvider theme={webLightTheme}>
      <Stack tokens={{ childrenGap: 5 }}>
        <Controller
          as={UtcDatePicker}
          label="Incorporated Date"
          id="incorporatedDate"
          name="incorporatedDate"
          control={control}
          allowTextInput
          defaultValue={data?.incorporatedDate}
          textField={{
            name: 'incorporatedDate',
            errorMessage: errors?.incorporatedDate?.message,
          }}
          onSelectDate={(utcDateString: string): void => {
            setValue('incorporatedDate', utcDateString);
          }}
        />
        <Controller
          name="wwArea"
          control={control}
          defaultValue={data?.wwArea || ''}
          render={({ onChange, onBlur, value, name, ref }): React.ReactElement => (
            <Field label="WW Area" validationMessage={errors?.wwArea?.message as string}>
              <Input
                id="wwArea"
                onChange={onChange}
                onBlur={onBlur}
                value={value}
                name={name}
                ref={ref}
                readOnly
                disabled
              />
            </Field>
          )}
        />
        <Controller
          name="region"
          control={control}
          defaultValue={data?.region || ''}
          render={({ onChange, onBlur, value, name, ref }): React.ReactElement => (
            <Field label="Region" validationMessage={errors?.region?.message as string}>
              <Input
                id="region"
                onChange={onChange}
                onBlur={onBlur}
                value={value}
                name={name}
                ref={ref}
                readOnly
                disabled
              />
            </Field>
          )}
        />
      </Stack>
    </FluentProvider>
  );
};

export default IncorporationHierarchyForm;
